import React from 'react'

export const Context = React.createContext({})



// WEBPACK FOOTER //
// src/components/Settings.js